// extracted by mini-css-extract-plugin
export default {"container":"_2Gnx","content":"_2S-F","loading":"IQMW"};